import { Permission, PermissionsHelper } from "~/utils/permission";
import { Data } from "~/utils/data";
import { ExtendedUserPermissions } from "~/utils/interfaces";
import Vue from "vue";
import { sdk } from "./coode-sdk-config";

export const ROLES = {
    ADMIN: "Admin",
    SITEUSER: "SiteUser",
    USER: "User",
} as const;

export class User {
    public static get canReadSingleSitePage(): boolean {
        return this.hasPermission(Permission.SINGLE_SITE_PAGE_READ);
    }

    public static async getUserData(): Promise<ExtendedUserPermissions> {
        return sdk.localStorage.getPermissionsLocalStorage() as ExtendedUserPermissions;
    }

    public static async getPerm(): Promise<Permission[]> {
        const userData = await this.getUserData();
        const permissions = PermissionsHelper.parsePermissionInclusions(
            userData.permissions.map((p) => p.name) as Permission[]
        );
        
        Data.Instance.userPermissions = permissions
        
        return permissions
    }

    public static hasPermission(permission: Permission): boolean {
        const userPermissions = Data.Instance.userPermissions;

        if (userPermissions.includes(Permission.ACCESS_ALL)) {
            return true;
        }

        return userPermissions.includes(permission);
    }

    public static async loadUserPermissionsIntoData(): Promise<void> {
        Data.Instance.userPermissions = await this.getPerm();
    }

    public static async signOut(): Promise<void> {
        return sdk?.auth.logout()
    }
}
